import { useQuery } from "@tanstack/react-query";
import useRevenue from "../utils/useRevenue";

export default function useHomeRevenueKPIsData(
  start_date,
  end_date,
  collections = ["all"],
  zones = ["all"]
) {
  const { getRevenueKPIs } = useRevenue();
  const { data, isLoading } = useQuery({
    queryKey: ["revenueKPIs", start_date, end_date, collections, zones],
    queryFn: () => getRevenueKPIs({ start_date, end_date, collections, zones }),
  });
  return {
    data: data?.data,
    isLoading,
  };
}
